<template>
  <ul
    v-if="open"
    :id="id"
    role="listbox"
    class="absolute inset-x-0 top-full z-[70] overflow-hidden rounded-b-md bg-white py-1 shadow-lg"
  >
    <li
      v-for="(suggestion, index) in suggestions"
      :id="`${id}-option-${index}`"
      :key="suggestion"
      role="option"
      :aria-selected="index === activeIndex"
      class="notranslate cursor-pointer px-3 py-2 text-sm text-[--color-neutral-black]"
      :class="{ 'bg-[--color-brand-forrest-green-05]': index === activeIndex }"
      translate="no"
      @mouseenter="emit('activate', index)"
      @pointerdown.prevent="emit('select', suggestion)"
    >
      <span>{{ prefix(suggestion) }}</span><strong>{{ suffix(suggestion) }}</strong>
    </li>
  </ul>
  <span v-else class="hidden" aria-hidden="true" />
</template>

<script setup lang="ts">
const props = defineProps<{
  activeIndex: number;
  id: string;
  open: boolean;
  query: string;
  suggestions: string[];
}>();

const emit = defineEmits<{
  activate: [index: number];
  select: [suggestion: string];
}>();

function prefix(suggestion: string): string {
  return suggestion.slice(0, props.query.trim().replace(/\s+/g, ' ').length);
}

function suffix(suggestion: string): string {
  return suggestion.slice(props.query.trim().replace(/\s+/g, ' ').length);
}
</script>
